const FormC = () =>{
    return(
        <>
           <form className="mobile-form" id="mobile-form" action="https://formspree.io/f/mjvlzqnw" method="post">
                <label htmlFor="name">Name</label>
                <input type="text" maxLength="30" required placeholder="Full name" name="name" id="name"/>
                <label htmlFor="email-address">Email</label>
                <input type="email" required placeholder="Email address" name="email" id="email-address"/>
                <label htmlFor="text">Message</label>
                <textarea maxLength="500" required placeholder="Enter message here" name="textarea" id="text"></textarea>
                <small id="smText"></small>
                <input type="submit" value="Get in touch" className="submit"/>
            </form> 
        </>
    )
}
export default FormC